import React from "react";

import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";
import { Portait6Style } from "./css/Portrait6Style";
const square_1_1 = (props) => {
  return (
    <Portait6Style>
      <div className="container_two_six">
        <TemplateLogo logo={props.logo} />
        <TemplateWatermark watermark={props.watermark} />
        <div className="back-layer">
          <TemplateImage slideType={props.slideType} file={props.file} />
        </div>
        <div className="front-layer">
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
          <div className="col">
            <div className="fw" />
          </div>
        </div>
        <div className="text-wrappers">
          <TemplateText
            id={props.id}
            text={props.text}
            textStyle={props.textStyle}
            editStatus={props.editStatus}
            onInputSlideText={props.onInputSlideText}
          />
        </div>
      </div>
    </Portait6Style>
  );
};

export default square_1_1;
